import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { paths } from 'src/routes/paths';
import { createTask } from 'src/api/kanbanModifyByValdo';
import { enqueueSnackbar } from 'notistack';
import * as uploadImageService from './editImage.service';

// Action pour charger l'organisation existante


export const editImageFormationSession = createAsyncThunk(
       'editImageFormationSession/uploadImage',
       async ( { imageObject, cancelToken, pathCall } ) => uploadImageService.uploadImage( imageObject, cancelToken )
);


export const uploadImageSlice = createSlice( {
       name: 'editImageFormationSession',
       initialState: {
              imageObjectGet: {},
              isUploadingImage: false,
              uploadImagedSuccess: false,

       },
       reducers: {

              resetDataAfterRequete: ( state ) =>
              {

                     state.uploadImagedSuccess = false;
                     state.isUploadingImage = false;
                     state.imageObjectGet = {}


                     // console.log( 'reset appeler', state.deleteFormationSuccess );

              },
       },











       extraReducers: ( builder ) =>
       {




              // Cas pour l' upload des images'
              builder
                     .addCase( editImageFormationSession.pending, ( state ) =>
                     {
                            state.isUploadingImage = true;
                            state.uploadImagedSuccess = false;
                     } )
                     .addCase( editImageFormationSession.fulfilled, ( state, action ) =>
                     {
                            state.isUploadingImage = false;
                            state.uploadImagedSuccess = true;
                            // console.log( 'image uploader avec succès:', action.payload );
                            // enqueueSnackbar( 'image uploader avec succès' );
                            state.imageObjectGet = { ...state.imageObjectGet, ...action.payload };
                            // console.log( state.imageObjectGet );

                     } )
                     .addCase( editImageFormationSession.rejected, ( state, action ) =>
                     {
                            state.isUploadingImage = false;
                            state.uploadImagedSuccess = false;
                            state.msg = action?.payload?.data ? action.payload.message : action.error.message;
                            // console.log("Erreur lors de l'upload de l'image", action.data);
                            // console.log("Message de l'Erreur:", state.msg);
                     } );
       },
} );



// Exportation des actions et du reducer
export const { resetDataAfterRequete } = uploadImageSlice.actions;
export default uploadImageSlice.reducer;
